import { render, staticRenderFns } from "./pedidosModelo.vue?vue&type=template&id=4dd91d76&scoped=true&"
import script from "./pedidosModelo.vue?vue&type=script&lang=js&"
export * from "./pedidosModelo.vue?vue&type=script&lang=js&"
import style0 from "./pedidosModelo.vue?vue&type=style&index=0&id=4dd91d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd91d76",
  null
  
)

export default component.exports